// components/RouteWrapper.jsx
import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';

export const RouteWrapper = ({ component: Component }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');

  // If no token exists and we're not on the login page, redirect to login.
  if (!token && location.pathname !== '/login') {
    return <Navigate to="/login" replace />;
  }

  // If a token exists and the user is on the login page, redirect to dashboard.
  if (token && location.pathname === '/login') {
    return <Navigate to="/dashboard" replace />;
  }

  // Otherwise, render the component.
  return <Component key={location.pathname} />;
};
